import ResourceCalendarsGrid from './resource-calendars-grid';
import { useUserSettings } from '../../../utils/use-user-settings';
import { getListOfBuildings, UserKeys } from '../../../api/users-api';
import { useQuery } from '@tanstack/react-query';
import { Messages } from '../../../utils/message-constants';

export default function ResourceCalendarsPage() {
  const {
    calendarRoles,
    changeLogRoles,
    administrationRoles,
    primaryDomain,
    loggedInUser,
  } = useUserSettings();

  const { data: buildingsList, isLoading: buildingsLoading } = useQuery({
    queryKey: [UserKeys.BuildingsList],
    queryFn: () => getListOfBuildings(),
    meta: {
      errorMessage: Messages.Errors.Network.Loading('buildings'),
    },
  });

  return (
    <ResourceCalendarsGrid
      administrationRoles={administrationRoles}
      calendarRoles={calendarRoles}
      changeLogRoles={changeLogRoles}
      primaryDomain={primaryDomain}
      loggedInUser={loggedInUser}
      buildingsList={buildingsList || []}
      buildingsLoading={buildingsLoading}
    />
  );
}
